import moment from "moment";

const getPropertyValue = (obj, property) => {
  if (Array.isArray(property)) {
    const foundProperty = property.find((prop) => obj[prop]);

    return foundProperty ? obj[foundProperty] : undefined;
  }

  return obj[property];
};

/**
 * @param {Array<Object>} activities
 * @param {string | string[]} [dateProperty]
 */
export const groupActivitiesByDate = (
  activities,
  dateProperty = "createdOn"
) => {
  const grouped = {};

  activities.forEach((activity) => {
    const date = new Date(getPropertyValue(activity, dateProperty));
    const dateKey = date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });

    if (!grouped[dateKey]) {
      grouped[dateKey] = [];
    }
    grouped[dateKey].push(activity);
  });

  return grouped;
};

export const buildActivityDateFilter = (dateRange) => {
  if (!dateRange?.startDate) return undefined;
  const start = moment(dateRange.startDate).startOf("day").toDate();
  const end = moment(dateRange.endDate ?? dateRange.startDate)
    .endOf("day")
    .toDate();
  return { createdOn: { ge: start, le: end } };
};

/**
 * @param {Array<Object>} activities
 * @param {string | string[]} [dateProperty]
 */
export const groupActivitiesForTimeline = (
  activities,
  dateProperty = "createdOn"
) => {
  const grouped = {};

  activities.forEach((activity) => {
    const date = new Date(getPropertyValue(activity, dateProperty));
    const timeKey = date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });

    if (!grouped[timeKey]) {
      grouped[timeKey] = [];
    }

    grouped[timeKey].push(activity);
  });

  return grouped;
};
